module.exports = __webpack_public_path__ + "static/img/li_top2.32d0ad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/li_top2.png
// module id = vMta
// module chunks = 1